export default __webpack_public_path__ + "static/media/close.da02b1b8.svg";